import { DashboardWidgetSpec } from "../../../common/dashboard-spec";
import { FormState } from "../_form-state";

/**
 * Updates the given `form` state based on the provided value.
 *
 * This function does not parse the `yaml` but takes the YAML string processed to an unknown value.
 *
 * @param form - The form state object to update.
 * @param spec - The specification object.
 */
export function unknownToForm(form: FormState, spec: unknown): void {
	const result = DashboardWidgetSpec.schema.safeParse(spec);

	if (result.success) {
		FormState.setInput(FormState.specToInput(result.data), form);
	}
}
